import {
    BetDistributionSectionContainer,
    BetDistributionSectionTitle,
} from "./BetDistributionSection.styles";
import { MultiPartProgressbar } from "./MultiPartProgressbar";
import { ProgressbarPartType } from "./MultiPartProgressbar.types";
import { getMappedBetStatistics } from "../Hooks/useBetStatistics";
import { useEffect, useState } from "react";

export function BetDistributionSection({ postId }: { postId: string }) {
    const [barsData, setBarsData] = useState<ProgressbarPartType[]>();

    useEffect(() => {
        getMappedBetStatistics(postId).then(setBarsData);
    }, []);

    if (!barsData?.length) {
        return null;
    }

    return (
        <BetDistributionSectionContainer>
            <BetDistributionSectionTitle>
                Tippverteilung
            </BetDistributionSectionTitle>
            <MultiPartProgressbar parts={barsData} />
        </BetDistributionSectionContainer>
    );
}
